import {useCallback, useEffect, useState} from "react";
import {client} from "../../api/client";
import useToken from "../useToken";

export function useDashboardStats() {
    const {token} = useToken();
    const [stats, setStats] = useState({
        counts: null,
        amounts: null,
        scopedCustomerIds: null,
        alertCenter: null,
    });
    const [loading, setLoading] = useState(true);

    const fetchStats = useCallback(() => {
        setLoading(true);
        client('dashboard/stats', {token})
            .then(result => {
                setStats({
                    counts: result.counts,
                    amounts: result.amounts,
                    scopedCustomerIds: result.scopedCustomerIds,
                    alertCenter: result.alertCenter,
                });
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [token]);

    useEffect(() => {
        fetchStats();
    }, [fetchStats]);

    return {stats, loading, refetch: fetchStats};
}
